/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert[_ngcontent-%COMP%]{padding:.2rem 1rem;margin-bottom:1rem;font-size:.75rem;border-radius:3px;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center}.error[_ngcontent-%COMP%]{background:#e93525;color:#fff}.success[_ngcontent-%COMP%]{background:#6dbe4c;color:#fff}.warning[_ngcontent-%COMP%]{background:#eaaa0a;color:#fff}cb-icon[_ngcontent-%COMP%]{margin-right:.75rem;font-size:1.5rem}"];
export { styles as styles };
